<template>
  <div class="designer-container">
    <div class="sidebar">
      <sidebar 
        :suggestions="[]"
        @selected-room="roomSelected"
        @add-product="addProduct"
        @add-arrangement="addArrangement"
        @load-room="loadRoom"
        :save-complete="!saveAnimate"
        @preview-arrangement="previewArrangement"
        @designer-disabled="e => designerDisabled = e"
        @show-popup="showPopupModal = true"/>
    </div>
    <div class="main room" 
      :class="{ 'designer-disabled' : designerDisabled }"
      @drop="dropped" 
      @dragover.prevent
      @mousedown.self="groupSelection($event, 'started')"
      @mouseup="groupSelection($event, 'finished')"
      @mousemove="groupSelection($event, 'in-progress')" ref="room">

      <div class="mode">{{ designerDisabled ? 'view mode' : 'design mode' }}</div>

      <img class="bgimage" :src="selectedRoom.url" @load="setBgDimensions" ref="bgimage"/>

      <NewProduct v-for="p in products" :key="p.uid"
        :product="p"
        :selected="selectedProducts.includes(p)"
        @selected="selectProduct(p)"
        @dragging="moveProducts"
        @duplicate="duplicateProduct(p)"
        @remove="removeProduct(p)"
      />

      <div v-if="arrangementPreviewProducts.length > 0" class="arrangement-preview">
        <NewProduct v-for="p in arrangementPreviewProducts" :key="p.uid" :product="p"/>
      </div>

      <div class="group-selection" v-show="groupSelectionInProgress" :style="groupSelectionStyle"></div>

      <div v-show="selectedProducts.length > 0" class="frame-selection">
        <frame-selection 
          @preview-frame="previewFrame"
          @frame-selected="frameSelected"
          :matteSize="selectedProductMatteSize"
          @preview-matte="previewMatte"
          @matte-color="matteColorUpdated"
          @matte-size="matteSizeUpdated"
          :selectedProductsTypes="selectedProductsTypes"/>
      </div>
    </div>

    <div class="save-room" @click="saveRoom()">
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-aperture"><circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line></svg>
      </div>
    </div>
    <div v-if="saveAnimate" class="save-animation"></div>

    <modal v-if="showPopupModal" @close="showPopupModal = false">
      <div slot="modal-content" class="popup">
        This feature is available in the full version.<br/>
        <a href="https://app.simplystudio.com">
          <div class="button">Start your FREE trial now!</div>
        </a>
      </div>
    </modal>

  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import FrameSelection from '@/components/designer/FrameSelection.vue'
import Modal from '@/components/utility/Modal.vue'
import NewProduct from '@/components/designer/Picture.vue'
import Sidebar from '@/components/designer/demo/DemoSidebar.vue'

export default {
  name: 'Designer',
  components: {
    FrameSelection,
    Modal,
    NewProduct,
    Sidebar,
  },
  created() {
    document.addEventListener('keydown', this.globalKeyListener)
    window.addEventListener('resize', this.setBgDimensions)
  },
  mounted() {
    this.selectedProducts = this.products
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.globalKeyListener)
    window.removeEventListener('resize', this.setBgDimensions)
  },
  data() {
    return {
      products: [{"type":"paper","photo":{"top":0,"left":0,"scale":100,"filename":"demo-02"},"accessURL":"","relativeX":0.3,"relativeY":0.2,"frame":{"src":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7.jpeg","thumbnail":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7_corner.png","borderImageSlice":32,"frameWidth":0.875,"name":"GLD7"},"matte":{"color":"#ffffff","size":2},"productSize":[12,12],"uid":"23e5927a-3f2b-4e6c-9b7f-e1a2843d80b7"},{"type":"paper","photo":{"top":-6,"left":-17,"scale":144.68831168831167,"filename":"demo-01"},"accessURL":"","relativeX":0.44,"relativeY":0.2,"frame":{"src":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7.jpeg","thumbnail":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7_corner.png","borderImageSlice":32,"frameWidth":0.875,"name":"GLD7"},"matte":{"color":"#ffffff","size":2},"productSize":[12,12],"uid":"d9f18d88-5e9d-4306-9855-55f38c40d440"},{"type":"paper","photo":{"top":0,"left":0,"scale":100,"filename":"demo-04"},"accessURL":"","relativeX":0.5800000000000001,"relativeY":0.2,"frame":{"src":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7.jpeg","thumbnail":"https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/GLD7_corner.png","borderImageSlice":32,"frameWidth":0.875,"name":"GLD7"},"matte":{"color":"#ffffff","size":2},"productSize":[12,12],"uid":"47422b19-afa6-4761-b605-a8c8ad4fcfc3"}],

      selectedRoom: {},

      calibrateRoom: false,
      calibrationUnit: {
        name: 'in',
        defaultNumber: 12,
      },

      photos: [],

      suggestions: [],
      saveAnimate: false,

      groupStart: null,
      groupDelta: null,
      groupEnd: null,

      selectedProducts: [],
      selectedProduct: null,

      framePreviewBackup: [],
      mattePreviewBackup: [],
      arrangementPreviewProducts: [],

      designerDisabled: false,

      showPopupModal: false,
    }
  },
  methods: {
    saveRoom() {
      // console.log(JSON.stringify(this.products))
      this.saveAnimate = true
      window.setTimeout(() => this.showPopupModal = true, 500)
    },
    dropped(e) {
      e.preventDefault()
      var type = e.dataTransfer.getData("product-type");
      if(type)
        this.addProduct(type, e.pageX, e.pageY)
      var arrangement = e.dataTransfer.getData("arrangement")
      if(arrangement) {
        this.addArrangement(JSON.parse(arrangement))
      }
    },
    addProduct(type, x = 0, y = 0) {
      let xPct = 0.3
      let yPct = 0.3
      if(x != 0 && y != 0) {
        xPct = (x-this.backgroundImage.x) / this.backgroundImage.width 
        yPct = (y-this.backgroundImage.y) / this.backgroundImage.height
      }
      let newProduct = {
        uid: uuidv4(),
        type: type,
        photo: {
          filename: '',
          relativeSize: 100,
          top: 0,
          left: 0,
          aspectRatio: 1,
        },
        accessURL: '',
        relativeX: xPct,
        relativeY: yPct,
        frame: {
          src: 'https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/HPL4.jpeg',
          thumbnail: 'https://storage.googleapis.com/simply-studio-pub-01/frames/simply-color/HPL4_corner.png',
          borderImageSlice: 73,
          frameWidth: 2,
          name: 'HPL4',
        },
        matte: {
          color: '#ffffff',
          size: 0
        },
        productSize: [12, 12],
      }
      if(type == 'wood') { // wood doesn't have frames or mattes, set to null values
        newProduct.frame = {
          src: '',
          thumbnail: '',
          borderImageSlice: 0,
          frameWidth: 0,
          name: '0'
        }
        newProduct.matte = {
          color: '#ffffff',
          size: 0
        }
      }
      this.products.push(newProduct)
    },

    addArrangement(arrangement) {
      arrangement = JSON.parse(arrangement)
      this.selectedProducts = []
      arrangement.forEach(product => {
        product.uid = uuidv4()
        product.relativeX = 0.3 + (product.relativeX*this.pixelPerUnit)/this.backgroundImage.width,
        product.relativeY = 0.2 + (product.relativeY*this.pixelPerUnit)/this.backgroundImage.height,
        this.products.push(product)
        this.selectedProducts.push(product)
      })
      // console.log(JSON.stringify(this.selectedProducts))
    },
    removeProduct(p) {
      this.products.splice(this.products.indexOf(p), 1)
    },
    removeSelectedProducts() {
      this.selectedProducts.forEach(p => this.removeProduct(p))
      this.selectedProducts = []
    },
    duplicateProduct(p) {
      let copy = JSON.parse(JSON.stringify(p))
      copy.uid = uuidv4()
      copy.relativeX += 0.05
      copy.relativeY += 0.05
      this.products.push(copy)
    },
    selectProduct(p) {
      this.selectedProduct = p
      if(!this.selectedProducts.includes(p)) {
        this.selectedProducts = [p]
      }
    },
    groupSelection(event, phase){
      if(phase == 'started') {
        this.groupStart = [event.pageX, event.pageY]
        this.groupEnd = null
      }
      if(this.groupSelectionInProgress && phase == 'in-progress') {
        this.groupDelta = [event.pageX, event.pageY]
      }
      if(phase == 'finished' && this.groupStart != null) {
        this.groupEnd = [event.pageX, event.pageY]
        this.selectedProducts = this.groupSelectedProducts
        this.groupDelta = null
        this.groupStart = null
        this.groupEnd = null
        // this.selectedProduct = null
        if(this.selectedProducts.length > 0)
          this.selectedProduct = this.selectedProducts[0]

      }
    },
    roomSelected(r) {
      this.selectedRoom = r
    },
    globalKeyListener(e) {
      if(this.selectedProducts.length > 0) {
        let multiplier = e.shiftKey ? 10 : 1
        switch(e.key) {
          case 'ArrowRight':
            this.moveProducts({deltaX: -1*multiplier, deltaY: 0})
            break
          case 'ArrowLeft':
            this.moveProducts({deltaX: 1*multiplier, deltaY: 0})
            break
          case 'ArrowDown':
            this.moveProducts({deltaX: 0, deltaY: -1*multiplier})
            break
          case 'ArrowUp':
            this.moveProducts({deltaX:0, deltaY: 1*multiplier})
            break
          case 'Backspace':
            this.removeSelectedProducts()
            break
          case 'Delete':
            this.removeSelectedProducts()
            break
        }
      }
    },
    moveProducts({deltaX, deltaY}) {
      const xPct = deltaX / this.backgroundImage.width
      const yPct = deltaY / this.backgroundImage.height
      this.selectedProducts.forEach(p => {
        p.relativeX -= xPct
        p.relativeY -= yPct
      })
    },
    loadRoom(r){
      this.selectedRoom = r.room
      let p = JSON.parse(JSON.stringify(r.products))
      p.forEach(p => p.uid = uuidv4())
      this.products = p
      this.$store.commit('mutate', {prop: 'percentBackgroundWidthPerUnit', value: r.calibration })
    },
    pointInRect(p, rect) {
      return p.x >= rect.xmin && p.x <= rect.xmax &&
             p.y >= rect.ymin && p.y <= rect.ymax
    },
    frameSelected(f) {
      this.selectedProducts.forEach(p => {
        p.frame = f
        this.framePreviewBackup = []
      })
    },
    matteColorUpdated(c) {
      this.selectedProducts.forEach(p => {
        p.matte.color = c
        if(p.matte.size == 0) {
          p.matte.size = 2
        }
        this.mattePreviewBackup = []
      })
    },
    matteSizeUpdated(n) {
      this.selectedProducts.forEach(p => {
        p.matte.size = n
      })
    },
    previewFrame(f) {
      if(f != null) {
        this.selectedProducts.forEach((p, i) => {
          this.framePreviewBackup[i] = p.frame
          p.frame = f
        })
      } else if(this.framePreviewBackup.length > 0) {
        this.selectedProducts.forEach((p, i) => {
          p.frame = this.framePreviewBackup[i]
        })
        this.framePreviewBackup = []
      }
    },
    previewMatte(c) {
      if(c != null) {
        this.selectedProducts.forEach((p, i) => {
          this.mattePreviewBackup[i] = p.matte.color
          p.matte.color = c
        })
      } else if(this.mattePreviewBackup.length > 0) {
        this.selectedProducts.forEach((p, i) => {
          p.matte.color = this.mattePreviewBackup[i]
        })
        this.mattePreviewBackup = []
      }
    },
    previewArrangement(products) {
      if(products == null) {
        this.arrangementPreviewProducts = []
        return
      }
      products = JSON.parse(products)
      products.forEach(p => {
        p.uid = uuidv4()
        p.relativeX = 0.3 + (p.relativeX*this.pixelPerUnit)/this.backgroundImage.width
        p.relativeY = 0.2 + (p.relativeY*this.pixelPerUnit)/this.backgroundImage.height
      })
      this.arrangementPreviewProducts = products
    },
    setBgDimensions() {
      if(!this.$refs.bgimage) {
        return
      }
      const box = this.$refs.bgimage.getBoundingClientRect()
      const bg = {
        x: box.left,
        y: box.top,
        width: box.width,
        height: box.height
      }
      this.$store.commit('mutate', { prop: 'backgroundImage', value: bg })
    },
    productCoords(p) {
      const tl = {
        x: p.relativeX*this.backgroundImage.width + this.backgroundImage.x, 
        y: p.relativeY*this.backgroundImage.height + this.backgroundImage.y
      }
      const tr = {
        x: p.relativeX*this.backgroundImage.width + this.backgroundImage.x + p.productSize[0]*this.pixelPerUnit, 
        y: p.relativeY*this.backgroundImage.height + this.backgroundImage.y
      }
      const bl = {
        x: p.relativeX*this.backgroundImage.width + this.backgroundImage.x, 
        y: p.relativeY*this.backgroundImage.height + this.backgroundImage.y + p.productSize[1]*this.pixelPerUnit 
      }
      const br = {
        x: p.relativeX*this.backgroundImage.width + this.backgroundImage.x + p.productSize[0]*this.pixelPerUnit, 
        y: p.relativeY*this.backgroundImage.height + this.backgroundImage.y + p.productSize[1]*this.pixelPerUnit 
      }
      return [tl, tr, bl, br]
    }
  },
  computed: {
    pixelPerUnit() {
      return this.$store.getters.pixelPerUnit
    },
    percentBackgroundWidthPerUnit() {
      return this.$store.getters.percentBackgroundWidthPerUnit
    },
    backgroundImage() {
      return this.$store.getters.backgroundImage
    },
    groupSelectionStyle() {
      const coords = this.groupSelectionCoords
      if(coords) {
        return `left:${coords.xmin}px;top:${coords.ymin}px;width:${coords.xmax-coords.xmin}px;height:${coords.ymax-coords.ymin}px;`
      }
      return {}
    },
    groupSelectedProducts() {
      const coords = this.groupSelectionCoords
      if(coords) {
        return this.products.filter(p => {
          let pCoords = this.productCoords(p)
          return this.pointInRect(pCoords[0], coords) ||
                 this.pointInRect(pCoords[1], coords) ||
                 this.pointInRect(pCoords[2], coords) || 
                 this.pointInRect(pCoords[3], coords)
        })
      }
      return []
    },
    groupSelectionActive() {
      return this.groupStart != null && this.groupEnd != null
    },
    groupSelectionCoords() {
      if(this.groupStart != null && (this.groupDelta != null || this.groupEnd != null)) {
        const end = this.groupEnd ? this.groupEnd : this.groupDelta
        const Xmin = Math.min(this.groupStart[0], end[0])
        const Xmax = Math.max(this.groupStart[0], end[0])
        const Ymin = Math.min(this.groupStart[1], end[1])
        const Ymax = Math.max(this.groupStart[1], end[1])
        return { xmin: Xmin, ymin: Ymin, xmax: Xmax, ymax: Ymax }
      }
      return null
    },
    groupSelectionInProgress() {
      return this.groupStart && !this.groupEnd
    },
    selectedProductsTypes() {
      return [...new Set(this.selectedProducts.map((e) => e.type))]
    },
    selectedProductMatteSize() {
      if(this.selectedProducts.length > 0)
        return this.selectedProducts[0].matte.size
      return 0
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.designer-container {
  display: flex;
  max-height: 100vh;
}

$sidebar-width: 370px;
.sidebar {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  min-width: $sidebar-width;
  max-width: $sidebar-width;
}
.main {
  flex: 1;

  img {
    max-width: 100%;
    max-height: 100%;
    pointer-events: none;
    user-select: none;
  }
}

.room {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.draggable-container {
  border: none;
  cursor:move;
}

.product {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.group-selection {
  position: absolute;
  border: 1px dashed $secondary;
  z-index: 1000;
}

.save-room {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 20px;
  font-size: 30px;
  cursor: pointer;
  opacity: 0.5;
  color: $primary;
  text-shadow: 0px 0px 2px rgba(255, 255, 255, 0.7);
  transition: 0.1s all;

  &:hover {
    opacity: 1;

    .icon {
      color: $secondary;
      transform: scale(1.3);
      transform: rotate(-45deg);
    }
  }

  .icon {
    filter: drop-shadow(0px 0px 1px rgba(255, 255, 255, 0.7));
    transition: 0.1s all;
    width: 40px;
    height: 40px;
  }

}
.save-animation {
  position: fixed;
  z-index: 9000;
  animation-name: save-animation;
  animation-duration: 0.5s;
}

.calibrate-room {

  .calibrate-room-icon {
    position: absolute;
    top: 0px;
    left: $sidebar-width;
    padding: 20px;
    font-size: 30px;
    cursor: pointer;
    opacity: 0.5;
    color: $primary;
    text-shadow: 0px 0px 2px rgba(255, 255, 255, 0.7);

    &:hover {
      opacity: 1;
    }

    .calibrate-instructions {
      opacity: 1;
      background-color: $red;
      color: white;
      margin-left: 10px;
      text-shadow: none;
    }
  }

  .calibration-active {
    color: $red;
    opacity: 1;
  }

  .calibrate-overlay {
    position: absolute;
    top: 0;
    left: $sidebar-width;
    right: 0;
    bottom: 0;
  }
}

.frame-selection {
  position: absolute;
  bottom: 20px;
  left: calc(50% - 25% + #{$sidebar-width}/2);
  width: 50%;
  margin: auto;
}

.designer-disabled {
  pointer-events: none;
}

.mode {
  position: absolute;
  top: 5px;
  left: calc(50% + #{$sidebar-width}/2);
  transform: translate(-50%, 0);
  color: rgba($secondaryText, 0.5);
  font-weight: bold;
  font-size: 12px;
}

.popup {
  background-color: white;
  padding: 80px;

  .button {
    margin-top: 30px;
    background-color: $primary;
    color: white;
    border-radius: $border-radius;
    padding: 20px;
    cursor: pointer;
    transition: 0.1s all;
    font-size: 20px;

    animation: pulse;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
}

@keyframes save-animation {
  0% {
    width: calc(100vw - 350px)  ;
    height: 100vh;
    top: 0;
    left: 350px;
    font-size: 100vh;
  }
  10% {
    background-color: rgba(0, 0, 0, 0.5);
  }
  100% {
    width: 180px;
    height: 32px;
    top: 64px;
    left: 180px;
    background-color: rgba(0, 0, 0, 0.2);
    font-size: 10px;
  }
}

</style>